'use strict'
const isEmpty_ = require('lodash/isEmpty')
const {
  READ_WRITE,
  READ
} = require('dbsm-common/src/dataset-configuration/readWriteModes')

const {
  isDatasetConfigured,
  getReadWriteMode,
  getCollectionName,
  selectCurrentRecord
} = require('../dataset-controller/rootReducer')

const reportDatasetActiveOnPage = (
  biLogger,
  state,
  connections,
  datasetType,
  isScoped,
  uniqueId,
  wixSdk
) => {
  if (isScoped || isEmpty_(connections) || !isDatasetConfigured(state)) {
    return
  }

  const readWriteMode = getReadWriteMode(state)

  if (
    [READ_WRITE, READ].includes(readWriteMode) &&
    selectCurrentRecord(state)
  ) {
    biLogger(
      Object.assign(
        {
          // ds_id: '',
          // ds_name: '',
          ds_type: datasetType,
          mode: readWriteMode,
          collection_name: getCollectionName(state),
          viewmode: wixSdk.window.viewMode
        },
        wixSdk.window.viewMode === 'Preview'
          ? {
              evid: 153
            }
          : {
              evid: 152,
              page_url: wixSdk.location.url
            }
      )
    )
  }
}

module.exports.reportDatasetActiveOnPage = reportDatasetActiveOnPage



// WEBPACK FOOTER //
// ./bi/events.js